'use strict';

import $ from 'jquery';
Dropzone.autoDiscover = false;
import 'dropzone';
import Swal from 'sweetalert2';
import dateRange from './dateRange';
import geoLocation from './geoLocation';
import croppie from 'croppie';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    organization_name_social: {
      label: 'Nome da organização*',
      placeholder: 'Nome da organização',
    },
    button_remove_organization: 'Remover',
    dz_default_message: 'Selecione os arquivos que deseja enviar',
    dz_cancel_upload: 'Cancelar o envio',
    dz_remove_file: 'Remover',
    dz_max_files_exceeded: 'Você já adicionou um arquivo',
    dz_file_too_big: 'Arquivo muito grande',
    dz_invalid_file_type: 'Este arquivo não é uma imagem',
    swal_attention: 'Atenção!',
    swal_fields_correctly: 'Preencha os campos corretamente',
    swal_materials_names: 'Preencha o nome dos materiais',
    swal_terms: 'Aceite a Política de Voluntariado para continuar',
    select: 'Selecione',
  },
  en: {
    organization_name_social: {
      label: 'Organization name*',
      placeholder: 'Organization name',
    },
    button_remove_organization: 'Remove',
    dz_default_message: 'Select the files you want to send',
    dz_cancel_upload: 'Cancel upload',
    dz_remove_file: 'Remove',
    dz_max_files_exceeded: 'You have already added a file',
    dz_file_too_big: 'Very large file',
    dz_invalid_file_type: 'This file is not an image',
    swal_attention: 'Warning!',
    swal_fields_correctly: 'Please fill out all the fields correctly',
    swal_materials_names: 'Fill in the materials name',
    swal_terms: 'Please, accept the VC’s Volunteering Policy to proceed.',
    select: 'Select',
  },
  es: {
    organization_name_social: {
      label: 'Nombre de la organización*',
      placeholder: 'Nombre de la organización',
    },
    button_remove_organization: 'Remover',
    dz_default_message: 'Selecciona los archivos que deseas enviar',
    dz_cancel_upload: 'Cancelar el envío',
    dz_remove_file: 'Eliminar',
    dz_max_files_exceeded: 'Ya has añadido un archivo',
    dz_file_too_big: 'Archivo muy grande',
    dz_invalid_file_type: 'Este archivo no es una imagen',
    swal_attention: 'Atención!',
    swal_fields_correctly: 'Rellena los campos correctamente',
    swal_materials_names: 'Rellene el nombre de los materiales',
    swal_terms: 'Acepta la Política de Voluntariado para continuar',
    select: 'Seleccione',
  },
};

const challengesForm = {
  settings: {
    _token: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
  },

  crop() {
    let crop;
    const $uploadCrop = document.getElementById('upload-crop');
    const $modalCrop = document.getElementById('modal-crop');
    const $inputImg = document.querySelector('.js-challenge-cover');

    $inputImg.addEventListener('change', function () {
      var reader = new FileReader();
      reader.onload = function (e) {
        crop = new croppie($uploadCrop, {
          enableExif: true,
          viewport: {
            width: 256,
            height: 170,
          },
          boundary: {
            width: 300,
            height: 200,
          },
        });

        crop
          .bind({
            url: e.target.result,
          })
          .then(function () {
            $modalCrop.classList.add('is-active');
          });
      };
      reader.readAsDataURL(this.files[0]);
    });

    $('.js-crop-challenge').on('click', function (e) {
      e.preventDefault();

      crop
        .result({
          type: 'canvas',
          size: { width: 512, height: 340 },
          format: 'jpeg',
          quality: 0.6,
        })
        .then(function (resp) {
          $('#cover_chosen').attr('src', resp);
          $('[name="cover"]').val(resp);
          $('#modal-crop').removeClass('is-active');
          setTimeout(() => {
            crop.destroy();
          }, 300);
        });
    });

    $('.js-crop-cancel').on('click', function () {
      document.getElementById('modal-crop').classList.remove('is-active');

      setTimeout(() => {
        crop.destroy();
      }, 300);
    });
  },

  bindActions() {
    $('.continue').on('click', function (e) {
      e.preventDefault();

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      if (currentSlide == 'term') {
        if (!$('#agree').is(':checked')) {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_terms, 'error');
          return false;
        }
      }

      if (currentSlide == 'first') {
        if (
          $("input[name='title']").val() == '' ||
          $("input[name='is_limited']:checked").val() == null ||
          ($("input[name='is_limited']:checked").val() == 1 && $("input[name='vacancies']").val() == '') ||
          ($('.js-others').is(':checked') && $('.js-type-description').val().length == 0) ||
          !tinymce.get('about-description').getContent().length ||
          !$('.js-activity:checked').length
        ) {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }
      }

      if (currentSlide == 'organization') {
        let $type = $('#c-type input[name="type"]:checked').length;

        if (!$('.js-state-filter').val() || !$('.js-cities').val() || !$('[name="school_address"]').val().length) {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }

        if (
          $type === 0 ||
          $('.js-organization option:selected').val() == '' ||
          ($('.js-organization option:selected').val() == '1' && $("input[name='school_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '2' && $("input[name='organization_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '2' && $("input[name='social_object']").val() == '') ||
          ($('.js-organization option:selected').val() == '3' && $("input[name='public_name']").val() == '') ||
          ($('.js-organization option:selected').val() == '5' && $("input[name='multi_organization_name[1]']").val() == '')
        ) {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }
      }

      if (currentSlide == 'due_date') {
        if ($("input[name='calendar']").val() == '' || $('#time_start_at').val() == '') {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }
      }

      if (currentSlide == 'materials') {
        if ($('[name="material_name[]"]').length) {
          for (let $i = 0; $i < $('[name="material_name[]"]').length; $i++) {
            let $el = $('[name="material_name[]"]')[$i];
            if (!$el.value.length) {
              Swal.fire(tr[lang].swal_attention, tr[lang].swal_materials_names, 'error');
              return false;
            }
          }
        }
      }

      if (currentSlide == 'plural') {
        if ($("[name='ods_id[]']").val() == '' || $("[name='plural_id[]']").val() == '') {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }

        if ($('[name="public_description"]').is(':visible') && $('[name="public_description"]').val() == '') {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }
      }

      $('.publish-challenge').on('click', function (e) {
        e.preventDefault();
        if ($('#cover_url').val() == '' && $('#customFile').val() == '') {
          Swal.fire(tr[lang].swal_attention, tr[lang].swal_fields_correctly, 'error');
          return false;
        }

        $('.form-signin').submit();
      });

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');

      window.scroll({ top: 0 });
    });

    $('.back').click(function (e) {
      e.preventDefault();
      window.scroll({ top: 0 });

      let currentSlide = $(this).attr('data-current');
      let nextSlide = $(this).attr('data-next');

      $('#' + currentSlide).removeClass('active');
      $('#' + nextSlide).addClass('active');
    });

    $('.js-limited').on('change', function () {
      if ($("input[name='is_limited']:checked").val() == '1') {
        $('#js-vacancies--total').removeClass('u-display--none');
      } else {
        $('#js-vacancies--total').addClass('u-display--none');
      }
    });

    function hideAll() {
      $('#c-school').addClass('u-display--none');
      $('#c-school input[name = "school_name"]').val('');
      $('#c-school input[name = "inep"]').val('');
      $('#c-school input[name = "register_number"]').val('');

      $('#c-organization').addClass('u-display--none');
      $('#c-organization input[name = "organization_name"]').val('');

      $('#c-public').addClass('u-display--none');
      $('#c-public input[name = "public_name"]').val('');

      $('#c-organizationlist').addClass('u-display--none');
      $('.js-organizationlist').val('');

      $('input[name = "multi_organization_name[1]"]').val('');
      $('input[name = "multi_organization_social_object[1]"]').val('');

      $('#add-social-object').addClass('u-display--none');
      $('#add-social-object input[name="social-object"]').val('');

      $('#contact-organization').addClass('u-display--none');
      $('#contact-organization input').val('');

      let num = $('.js-add-organization').attr('data-count');
      if (num > 1) {
        for (i = 2; i <= num; i++) {
          $('#organization-id-' + i).remove();
        }
      }
    }

    $("#c-type input[name='type']").on('change', () => {
      let type = $("input[name='type']:checked").val();
      $('#s-organization').removeClass('u-display--none');
      type == 'online' ? $('#c-address').addClass('u-display--none') : $('#c-address').removeClass('u-display--none');
    });

    $('.js-organization').on('change', function () {
      let type = $("input[name='type']:checked").val();

      if (this.value == 0) {
        $('#c-address input[name = "school_address"]').val('');
      }

      if (this.value == 1) {
        hideAll();
        $('#c-school').removeClass('u-display--none');
        $('#contact-organization').removeClass('u-display--none');
      } else if (this.value == 2) {
        hideAll();
        $('#c-organization').removeClass('u-display--none');
        $('#contact-organization').removeClass('u-display--none');
        $('#add-social-object').removeClass('u-display--none');
      } else if (this.value == 3) {
        hideAll();
        $('#c-public').removeClass('u-display--none');
        $('#contact-organization').removeClass('u-display--none');
      } else if (this.value == 4) {
        hideAll();
      } else if (this.value == 5) {
        hideAll();
        $('#c-organizationlist').removeClass('u-display--none');
      } else {
        hideAll();
      }
    });

    $(document).on('click', '.js-add-organization', function (e) {
      e.preventDefault();

      let num = parseInt($(this).attr('data-count')) + 1;

      let template = `
          <div id="organization-id-${num}">
            <label class="u-m-t-15">${tr[lang].organization_name_social.label}</label>
            <input type="text" class="form-control" name="multi_organization_name[${num}]" placeholder="${tr[lang].organization_name_social.placeholder}" maxlength="80">

            <button class="o-btn o-btn--danger u-p-x-0 js-drop-organization u-m-t-15" data-id="organization-id-${num}">
              <i class="fa fa-trash"></i>
                ${tr[lang].button_remove_organization}
            </button>            
          </div>`;

      $('.s-challenges--create-grid').append(template);

      $(this).attr('data-count', num);
    });

    $(document).on('click', '.js-drop-organization', function (e) {
      e.preventDefault();
      $('#' + $(this).attr('data-id')).remove();
    });

    $('.js-thumb').on('click', function () {
      document.getElementById('cover_chosen').src = $(this).attr('src');
      document.getElementById('cover_url').value = $(this).attr('src');
      document.querySelector('[name="cover"]').value = '';
    });

    var $typeDescruption = $('#type-description');
    $('.js-others').on('change', function () {
      if ($(this).is(':checked')) {
        $typeDescruption.slideDown();
      } else {
        $typeDescruption.slideUp();
        $('.js-type-description').val('');
      }
    });

    $('.js-activity').on('click', function () {
      var $box = $(this);
      if ($box.is(':checked')) {
        var group = "input:checkbox[name='" + $box.attr('name') + "']";
        $(group).prop('checked', false);
        $box.prop('checked', true);
        if ($box.attr('value') != 'Outros') {
          $('.js-type-description').val('');
          $typeDescruption.slideUp();
        }
      } else {
        $box.prop('checked', false);
      }
    });

    // Select2 ODS controller
    function formatOds(ods) {
      if (ods.icon) {
        var baseUrl = '/images/icons/ods';
        var $ods = $(
          '<span class="c-drop-template__title"><img src="' +
            baseUrl +
            '/' +
            ods.icon +
            '" class="c-drop-template__flag" /> ' +
            ods.text +
            '</span>'
        );
        return $ods;
      }
    }

    fetch(`${window.location.origin}/get/ods`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('input[name="_token"]').value,
      },
      body: JSON.stringify({
        challenge_id: document.querySelector('input[name="id"]') !== null ? document.querySelector('input[name="id"]').value : 0,
      }),
    })
      .then(response => (response.ok ? response.json() : console.log('Network response was not ok.')))
      .then(data => {
        $('#js-ods')
          .select2({
            placeholder: tr[lang].select,
            theme: 'classic',
            multiple: true,
            data: JSON.parse(data.ods),
            templateSelection: formatOds,
            templateResult: formatOds,
          })
          .val(data.odsSelected)
          .trigger('change');
      })
      .catch(error => {
        console.log('There has been a problem with your fetch operation: ' + error.message);
      });

    $('.js-plural')
      .select2({
        placeholder: tr[lang].select,
        theme: 'classic',
        multiple: true,
      })
      .on('select2:select', function (e) {
        if (e.params.data.text == 'Outros') {
          $('#public-description').slideDown();
        }
      })
      .on('select2:unselect', function (e) {
        if (e.params.data.text == 'Outros') {
          $('#public-description').slideUp();
          $('.js-public-description').val('');
        }
      });
  },

  dropzone() {
    new Dropzone('#myDropzone', {
      url: `${window.location.origin}/acoes-disponiveis/materiais/upload-arquivos`,
      paramName: 'gallery',
      maxFilesize: 10,
      maxFiles: 50,
      params: {
        _token: s._token,
        challenge_id: $('[name="id"]').val(),
      },
      previewTemplate: document.querySelector('#tpl').innerHTML,
      addRemoveLinks: true,
      dictDefaultMessage: tr[lang].dz_default_message,
      dictCancelUpload: tr[lang].dz_cancel_upload,
      dictRemoveFile: tr[lang].dz_remove_file,
      dictMaxFilesExceeded: tr[lang].dz_max_files_exceeded,
      dictFileTooBig: tr[lang].dz_file_too_big,
      dictInvalidFileType: tr[lang].dz_invalid_file_type,
      init: function () {
        this.on('success', function (file, response) {
          $('.added_photos').append('<input type="hidden" data-name="' + file.name + '" name="gallery[]" value="' + response + '"/>');

          let $item = $('<input type="hidden" data-name="' + file.name + '" name="material_name[]"/>');
          $('.added_photos').append($item);

          $(file.previewElement.querySelector('[data-item-name]')).on('keyup', function (e) {
            $item[0].value = e.target.value;
          });
        });
        this.on('removedfile', function (file, response) {
          $("input[name='gallery[]'], input[name='material_name[]']").each(function () {
            if ($(this).attr('data-name') == file.name) {
              $(this).remove();
            }
          });
        });
      },
    });
  },

  init() {
    _this.bindActions();
    _this.dropzone();
    dateRange.init();
    geoLocation.init();
    _this.crop();
  },
};

const s = challengesForm.settings,
  _this = challengesForm;

export default _this;
